// extracted by mini-css-extract-plugin
module.exports = {"comingSoon":"comingsoon_comingSoon__XHDoZ","heading":"comingsoon_heading__a_OnK","message":"comingsoon_message__363CF"};